import { useCallback, useMemo } from "react";
import { useT } from "@sablier/v2-locales";
import {
  useAccount,
  useCoverRenounce,
  useMachineRenounce,
  useModalTransaction,
  useResetter,
  useStreamCurrent,
  useWarning,
} from "~/client/hooks";

export function useFormPrepare() {
  const { isReady, stream } = useStreamCurrent();
  const { state } = useWarning("renounce", stream);
  const isPrepared = useMemo(
    () => isReady && state === "ready",
    [isReady, state],
  );

  return {
    isPrepared,
  };
}

export function useFormSubmit() {
  const { stream, isReady } = useStreamCurrent();
  const { machine, send } = useMachineRenounce();
  const { setOpen, updateData } = useModalTransaction();
  const { doClose } = useCoverRenounce();
  const { signer, proxy } = useAccount();
  const { all: reset } = useResetter();
  const error = useMemo(() => machine.context.error, [machine.context.error]);
  const { t } = useT();

  const isSubmitting = useMemo(
    () => machine.value === "process" || machine.value === "validate",
    [machine.value],
  );

  const doSubmit = useCallback(() => {
    if (isReady) {
      send("SAVE", {
        payload: {
          api: {
            t,
            setOpen,
            updateData,
            reset: () => {
              doClose();
              void reset();
            },
          },
          signer,
          proxy,
          stream,
        },
      });
    }
  }, [
    doClose,
    isReady,
    reset,
    send,
    setOpen,
    signer,
    stream,
    updateData,
    t,
    proxy,
  ]);

  return {
    doSubmit,
    error,
    isSubmitting,
  };
}
